/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Current Miradi license
 */
import { ValidateUtils } from 'app/shared/utils';

export class MiradiLicense { 
    /**
     * License content (html)
     */
    content?: string;
    /**
     * License effective date
     */
    effectiveDate?: string;

    constructor(item?: Partial<MiradiLicense>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            content: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.content : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            effectiveDate: {
                type: 'date',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.effectiveDate : itemOrValue;

                    if (itemOrValue?.effectiveDate != null) {
                        if (itemOrValue.effectiveDate === '') {
                            itemOrValue.effectiveDate = undefined;
                        } else if (['int32', 'int64'].indexOf('date') >= 0) {
                            itemOrValue.effectiveDate = parseInt(itemOrValue.effectiveDate.toString(), 10);
                        } else if (['float'].indexOf('date') >= 0) {
                            itemOrValue.effectiveDate = parseFloat(itemOrValue.effectiveDate.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'date');
                    if (['uuid'].indexOf('date') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: MiradiLicense.isValid,
        };
    }

    static isValid(obj: MiradiLicense): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = MiradiLicense.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.content.isValid(item);
            result = result && validationObject.effectiveDate.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

